module.exports = __webpack_public_path__ + "img/4.74325850.png";